import React from "react";
import PropTypes from "prop-types";
import * as NotificationSapService from "../../../../services/NotificationSapService";
import { useTranslation } from "react-i18next";
import NotificationSapFormView from "./notificationSapForm.view";
import ShowDialog from "../../../utils/ShowDialog/ShowDialog";

const NotificationSapFormContainer = ({
  notificationSap,
  onCancel,
  onSuccess,
}) => {
  const { t } = useTranslation();
  console.log(notificationSap);

  const initialValues = {
    sapBatch: notificationSap?.sapBatch ?? "",
    sapQuantityEntry: notificationSap?.sapQuantityEntry ?? "",
    sapMaterial: notificationSap?.sapMaterial ?? "",
  };

  const handleSubmit = async (values) => {
    try {
      const payload = {};
      if (values.sapBatch !== undefined && values.sapBatch !== "") {
        payload.sapBatch = values.sapBatch;
      }
      if (
        values.sapQuantityEntry !== undefined &&
        values.sapQuantityEntry !== ""
      ) {
        payload.sapQuantityEntry = Number(values.sapQuantityEntry);
      }
      if (values.sapMaterial !== undefined && values.sapMaterial !== "") {
        payload.sapMaterial = values.sapMaterial;
      }

      if (Object.keys(payload).length === 0) {
        return;
      }

      const result = await NotificationSapService.update(
        notificationSap.uuid,
        payload,
      );

      let title = "";
      let text = "";
      let icon = "";
      if (result !== null) {
        title = t("forms.notificationSap.messages.update.title");
        text = t("forms.notificationSap.messages.update.success");
        icon = "success";
      } else {
        title = "Error";
        text = t("forms.notificationSap.messages.update.error");
        icon = "error";
      }

      ShowDialog(title, text, icon, false, "OK", false, () => {
        if (result !== null && onSuccess) {
          onSuccess();
        }
      });
    } catch (error) {
      ShowDialog(
        "Error",
        t("forms.notificationSap.messages.update.error"),
        "error",
        false,
        "OK",
      );
    }
  };

  return (
    <NotificationSapFormView
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  );
};

NotificationSapFormContainer.propTypes = {
  notificationSap: PropTypes.object,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default NotificationSapFormContainer;
